import { twMerge } from 'tailwind-merge';

import { AdvertisementFieldAccessor } from '~/api/field-accessors';
import type { CampaignInfoV2 } from '~/api/v2/schemas/campaign-info';

import { formatPoint, formatRate } from './format';
import { getPointData } from './get-point-data';

// 表記が特殊なので別コンポーネント
export function SitePointupCarouselPoint({ campaign }: { campaign: CampaignInfoV2 }) {
  const { isRate, value, firstAd, regularValue, hasPointup } = getPointData(campaign);

  if (hasPointup && isRate) {
    return (
      <div className="rounded-sm bg-red-50 px-1 py-3 text-center" data-testid="site-pointup-carousel-point">
        <span className="text-caption-s">株引換券</span>
        <div className="flex items-baseline justify-center gap-1">
          <span className="text-caption-s line-through">
            {regularValue !== undefined ? formatRate(regularValue) : '-'}%
          </span>
          <span className="text-caption-s">→</span>
          <span className="text-brand">
            <span className="text-headline-s">
              {firstAd ? formatRate(AdvertisementFieldAccessor.net(firstAd)) : '-'}
            </span>
            <span className="text-caption-s">%</span>
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-sm bg-red-50 px-1 py-3 text-center" data-testid="site-pointup-carousel-point">
      <span className="text-caption-s">株引換券</span>
      <div className="flex items-baseline justify-center gap-1">
        <span className={twMerge('text-headline-s', hasPointup && 'text-brand')}>{formatPoint(value, isRate)}</span>
        <span className="text-caption-s">{isRate ? '%' : '枚'}</span>
      </div>
    </div>
  );
}
